import React, { useEffect, useState } from "react";
import MCSSearchWords from "../Components/mcssearchwords";
import { translate } from '../Services/translation';

export default function MCSItem(props) {

    const {
        id,
        selectedFilters,
        heading,
        ingress,
        metaDescription,
        metaTitle,
        selectedCategory,
        url,
        fullUrl,
        displayName,
        availableFilters,
        addFilters,
        active,
        updated,
        editing,
        saveOrCancel,
        availableCategories,
        changeSelectedCategory,
        changeTextField,
        removeFilters,
        removeItem,
        activateItem,
        searchModel,
        saveButtonValue,
        removeButtonValue,
        rootFolderName,
        getAvailableFilters
    } = props;

    const [selected, setSelected] = useState(false);
    const [elementHeight, setElementHeight] = useState(0);
    const [elementHeightElement, setElementHeightElement] = useState();
    const [showFilterList, setShowFilterList] = useState(false);
    const [showCategoryList, setShowCategoryList] = useState(false);
    const [validationWarning, setValidationWarning] = useState('');
    const scaleBaseNo = 13.8;
    let title = url ? url : displayName;

    const selectItem = (e) => {
        setElementHeight(getElementHeight(e.currentTarget.nextElementSibling));
        setElementHeightElement(e.currentTarget.nextElementSibling);
        setSelected(!selected);
        setShowFilterList(false);
        setShowCategoryList(false);
    }

    const getElementHeight = (element) => {
        if (element) {
            if (element.clientHeight > 0) {
                return element.clientHeight + 156;
            }
            else {
                return element.offsetHeight + 156;
            }
        }
    }

    const toggleMenus = (menuType) => {
        if (menuType == "Category") {
            if (!showCategoryList) {
                document.getElementById(id).classList.add("overflow-visible");
                setShowCategoryList(true);
                setShowFilterList(false);
            }
            else {
                document.getElementById(id).classList.remove("overflow-visible");
                setShowCategoryList(false);
                setShowFilterList(false);
            }
        }
        else {

            getAvailableFilters(id, selectedCategory.id);

            if (!showFilterList) {
                document.getElementById(id).classList.add("overflow-visible");
                setShowFilterList(true);
                setShowCategoryList(false);
            }
            else {
                document.getElementById(id).classList.remove("overflow-visible");
                setShowFilterList(false);
                setShowCategoryList(false);
            }
        }
    }

    const changeSelectedItemCategory = (itemId) => {
        setValidationWarning("");
        setShowCategoryList(false);
        changeSelectedCategory(itemId, id)
    }

    const enableButton = () => {
        activateItem(id, !active)
    }

    const addItemFilters = (groupId, groupName, filterId, name, id) => {
        addFilters(groupId, groupName, filterId, name, id);
        setElementHeight(getElementHeight(elementHeightElement));
    }

    const validateSaveOrCancel = (save, id) => {
        if (save) {
            if (selectedCategory.name === null || selectedCategory.name === '') {
                setValidationWarning(translate("mcs.categorymissing"));
                return;
            }
            else if (url === null || url === "") {
                setValidationWarning(translate("mcs.urlmissing"));
                return;
            }
        }
        saveOrCancel(save, id);
    }

    const setChangeTextField = (id, textField, value) => {
        setValidationWarning("");
        changeTextField(id, textField, value);
    }

    return (
        <>
            <div id={id} className={selected ? "mcs__item-wrapper mcs__item-wrapper--expanded column" : "mcs__item-wrapper column"} style={selected ? { maxHeight: elementHeight, marginBottom: elementHeight / scaleBaseNo } : {}}>
                <div className={active ? "mcs__enable-button" : "mcs__enable-button mcs__enable-button--disabled"} onClick={() => enableButton()}><div></div></div>
                <a href={fullUrl} title={translate("mcs.visitpage")}><i class={active ? "fas fa-globe-americas mcs__visit" : "fas fa-globe-americas mcs__visit mcs__visit--inactive"}></i></a>
                <i className="far fa-times-circle mcs__remove" onClick={() => removeItem(id)}></i>
                <div className="mcs__title-wrapper" onClick={(event) => selectItem(event)}>
                    <i className={selected ? "fas fa-chevron-down rotate-180" : "fas fa-chevron-down"}></i>
                    <h3><span className="mcs__parent-category">{selectedCategory && selectedCategory.name} <i class="far fa-arrow-right"></i></span> {title}</h3>
                </div>
                <div className="mcs__body-wrapper">
                    <div className={selected ? "mcs__info-wrapper mcs__info-wrapper--show col-6" : "mcs__info-wrapper col-6"}>
                        <div className="mcs__availableFilters-container mcs__container col-12">
                            <div className="columns">
                                <div className="mcs__filter-wrapper">
                                    <div className="mcs__filter-controller" onClick={() => toggleMenus("Filter")}>
                                        <span>Valj filter</span>
                                        <i className={showFilterList ? "fas fa-chevron-down rotate-180" : "fas fa-chevron-down"}></i>
                                    </div>
                                    {availableFilters && availableFilters.length > 0 &&
                                        <div className={showFilterList ? "mcs__filter-list mcs__filter-list--show" : "mcs__filter-list"}>
                                            {availableFilters.map((item, index) => (
                                                <React.Fragment key={"filter-" + index}>
                                                    {(item.groupName != "" && item.filterItemList.length > 0) &&
                                                        <span key={"filterGroup-" + index} className="mcs__filter-object">{item.groupName}</span>
                                                    }
                                                    {item.filterItemList && item.filterItemList.map((filterItem, index) => (
                                                        filterItem.id != "" &&
                                                        <span key={"filterItem-" + index} className="mcs__filter-object--item" onClick={() => addItemFilters(item.groupId, item.groupName, filterItem.id, filterItem.name, id)}>{filterItem.name}</span>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="mcs__filter-container columns">
                                {selectedFilters && selectedFilters.map((item, index) => (
                                    item.filterItemList && item.filterItemList.length > 0 &&
                                    <React.Fragment key={"filter-item-list" + index}>
                                        <div className="mcs__filter-header">{item.groupName}</div>
                                        <div className="mcs__filter-item-list">
                                            {item.filterItemList.map((filterItem, index) => (
                                                <div className="mcs__filter" key={"selectedFilter-" + index}>
                                                    <span>{filterItem.name}</span>
                                                    <div>
                                                        <i className="fas fa-times" onClick={() => removeFilters(item.groupId, filterItem.id, filterItem.name, id)}></i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                        <div className="mcs__availableCategories-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.category")}:</h4>
                                <div className="mcs__category-wrapper">
                                    <div className="mcs__category-controller" onClick={() => toggleMenus("Category")}>
                                        <span>{selectedCategory.name}</span>
                                        <i className={showCategoryList ? "fas fa-chevron-down rotate-180" : "fas fa-chevron-down"}></i>
                                    </div>
                                    <div className={showCategoryList ? "mcs__category-list mcs__category-list--show" : "mcs__category-list"}>
                                        {availableCategories && availableCategories.map((item, index, array) => (
                                            item.name != "" ? <span key={"category-" + index} className="mcs__category-object" onClick={() => changeSelectedItemCategory(item.id)}>{item.name}</span> : <span key={"category-" + index} className="mcs__category-object" onClick={() => changeSelectedCategory(item.id, id)}>{item.id}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mcs__url-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.url")}:</h4>
                                <input tabIndex={!selected ? "-1" : ""} onChange={(event) => setChangeTextField(id, "url", event.target.value)} value={url} />
                            </div>
                        </div>
                        <div className="mcs__heading-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.heading")}:</h4>
                                <input tabIndex={!selected ? "-1" : ""} onChange={(event) => setChangeTextField(id, "heading", event.target.value)} value={heading} />
                            </div>
                        </div>
                        <div className="mcs__metatitle-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.metatitle")}:</h4>
                                <input tabIndex={!selected ? "-1" : ""} onChange={(event) => changeTextField(id, "metaTitle", event.target.value)} value={metaTitle} />
                            </div>
                        </div>
                        <div className="mcs__ingress-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.ingress")}:</h4>
                                <textarea draggable={false} tabIndex={!selected ? "-1" : ""} onChange={(event) => setChangeTextField(id, "ingress", event.target.value)} value={ingress} />
                            </div>
                        </div>
                        <div className="mcs__metadescription-container mcs__container col-6">
                            <div className="columns">
                                <h4>{translate("mcs.metadescription")}:</h4>
                                <textarea draggable={false} tabIndex={!selected ? "-1" : ""} onChange={(event) => setChangeTextField(id, "metaDescription", event.target.value)} value={metaDescription} />
                            </div>
                        </div>
                        <div className="mcs__edited-container mcs__container col-12 columns">
                            {editing &&
                                <>
                                    <div onClick={() => validateSaveOrCancel(true, id)}>{translate("mcs.save")}</div><div onClick={() => validateSaveOrCancel(false, id)}>{translate("mcs.cancel")}</div>
                                </>
                            }
                            {validationWarning && <h6>{validationWarning}</h6>}
                        </div>
                    </div>
                    <div className={selected ? "mcs__info-wrapper mcs__info-wrapper--show mcs__data-wrapper col-6" : "mcs__info-wrapper mcs__data-wrapper col-6"}>
                        <div className="mcs__container column col-12">
                            <MCSSearchWords {...{
                                searchWords: searchModel.searchWords,
                                otherSearchWords: searchModel.otherSearchWords,
                                trafic: searchModel.trafic,
                                saveButtonValue,
                                removeButtonValue,
                                id
                            }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

